import { useEffect, useRef, useState } from "react";
import Card from "./card";
import { Link } from "react-router-dom";
import config from "../config";

function Kebablist() {
  const [reviews, setReviews] = useState(null);
  const hasFetched = useRef(false);

  const getReviews = async () => {
    const response = await fetch(`${config.BaseUrl}/reviews`, {
      method: "GET",
    });

    if (!response.ok) alert("could not fetch from Server");

    const data = await response.json();

    setReviews(data.reviews);
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    if (!reviews || reviews.lenght == 0) getReviews();
  }, []);

  const renderReviews = () => {
    if (!reviews || !Array.isArray(reviews)) {
      return <p>Lade Reviews...</p>; // falls reviews undefined ist
    }

    return reviews.map((r) => (
      <Link
        key={r._id}
        to={`/review/${r._id}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <Card
          key={r._id}
          title={r.title}
          text={r.text}
          address={r.address}
          views={r.views}
          rating={r.rating}
          image={r.image}
        />
      </Link>
    ));
  };
  return (
    <div>
      <h3>Kebabetablissements</h3>

      <div className="flex-grid">{renderReviews()}</div>
    </div>
  );
}

export default Kebablist;
